<template>
  <div>
    <section-title has-line title="Información de Archivos de Pagos" />
    <payment-file-info-row
      empty-text="No hay cuentas a crear en el jornal del pago"
      icon="fas fa-plus"
      :items="accountsToCreate"
      :on-download-file="onDownloadFile"
      :payment-journal-status-id="paymentJournalStatusId"
      title="Cuentas a Crear"
      @on-delete-file-answer="onDeleteFileAnswerHandler"
      @on-download-account-file="onDownloadAccountFile"
      @on-generate-new-file="onGenerateNewFileHandler"
      @on-save-answer-files="onSaveAnswerFiles"
    />

    <payment-file-info-row
      class="mt-4"
      empty-text="No hay cuentas a actualizar en el jornal del pago"
      icon="fas fa-exchange-alt"
      :items="accountsToUpdate"
      :on-download-file="onDownloadFile"
      :payment-journal-status-id="paymentJournalStatusId"
      title="Cuentas a Actualizar"
      @on-delete-file-answer="onDeleteFileAnswerHandler"
      @on-download-account-file="onDownloadAccountFile"
      @on-generate-new-file="onGenerateNewFileHandler"
      @on-save-answer-files="onSaveAnswerFiles"
    />

    <payment-file-info-row
      class="mt-4"
      empty-text="No hay cuentas a pagar en el jornal del pago"
      icon="fas fa-dollar-sign"
      :items="accountsToPay"
      :on-download-file="onDownloadFile"
      :payment-journal-status-id="paymentJournalStatusId"
      title="Cuentas a Pagar"
      @on-delete-file-answer="onDeleteFileAnswerHandler"
      @on-download-account-file="onDownloadAccountFile"
      @on-generate-new-file="onGenerateNewFileHandler"
      @on-save-answer-files="onSaveAnswerFiles"
    />
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import PaymentFileInfoRow from './PaymentFileInfoRow';
import peiServices from '@/modules/app/api.js';
import {
  getPaymentJournalInterfaceFiles as _getPaymentJournalInterfaceFiles,
  createAccountSetupFile as _createAccountSetupFile,
  createBenefitIssuanceFile as _createBenefitIssuanceFile,
  getJornalAccountFile as _getJornalAccountFile,
  saveAnswerFiles as _saveAnswerFiles,
  updateAccountSetupFile as _updateAccountSetupFile,
  deleteInterfaceFileAnswer as _deleteInterfaceFileAnswer,
} from '@/modules/shared/scholarship.api.js';

import interfaceFileTypeCodes from '@/utils/constants/interfaceFileTypeCodes.js';
import _generalApi from '@/modules/app/api';
import alertMixin from 'utils/mixins/alert.mixin';

export default {
  name: 'PaymentFileInfo',
  components: {
    SectionTitle,
    PaymentFileInfoRow,
  },
  mixins: [alertMixin],
  props: {
    paymentJournalId: {
      type: String,
      required: true,
    },
    paymentJournalStatusId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      accountsToCreate: [],
      accountsToUpdate: [],
      accountsToPay: [],
    };
  },
  async mounted() {
    await this.callInterfaceFiles();
  },
  methods: {
    onDownloadFile(documentId) {
      peiServices.downloadDocumentByAttachmentId(documentId);
    },
    async callInterfaceFiles() {
      const responses = await Promise.all([
        _getPaymentJournalInterfaceFiles(
          this.paymentJournalId,
          interfaceFileTypeCodes.AccountToCreate
        ),
        _getPaymentJournalInterfaceFiles(
          this.paymentJournalId,
          interfaceFileTypeCodes.AccountToUpdate
        ),
        _getPaymentJournalInterfaceFiles(
          this.paymentJournalId,
          interfaceFileTypeCodes.AccountToPay
        ),
      ]);

      this.accountsToCreate = this.mapAnswerFile(responses[0].data);
      this.accountsToUpdate = this.mapAnswerFile(responses[1].data);
      this.accountsToPay = this.mapAnswerFile(responses[2].data);
    },
    mapAnswerFile(arr) {
      return arr.map((s) => {
        s.answerFileNames = `${s.logDocumentAttachment ? 'LOG' : ''} ${
          s.rejDocumentAttachment ? ', REJ' : ''
        }`;

        if (!s.logDocumentAttachment && s.rejDocumentAttachment) {
          s.logFileEmpty = true;
        }
        if (s.logDocumentAttachment && !s.rejDocumentAttachment) {
          s.rejFileEmpty = true;
        }
        return s;
      });
    },
    async onGenerateNewFileHandler({ fileTypeCode }) {
      if (fileTypeCode) {
        if (fileTypeCode === interfaceFileTypeCodes.AccountToPay) {
          const { data: updateResponse } = await _createBenefitIssuanceFile(
            this.paymentJournalId,
            fileTypeCode
          );
          if (updateResponse) {
            this.callInterfaceFiles();
          }
        } else if (fileTypeCode === interfaceFileTypeCodes.AccountToUpdate) {
          const { data: updateResponse } = await _updateAccountSetupFile(
            this.paymentJournalId
          );
          if (updateResponse) {
            this.callInterfaceFiles();
          }
        } else {
          const { data: updateAccountResponse } = await _createAccountSetupFile(
            this.paymentJournalId,
            fileTypeCode
          );
          if (updateAccountResponse) {
            this.callInterfaceFiles();
          }
        }
      }
    },
    async onDownloadAccountFile(item) {
      if (item.interfaceFileId != null) {
        await _getJornalAccountFile(item.interfaceFileId, item.fileTypeCode)
          .then((response) => {
            _generalApi.ConvertToBlob(response.data);
          })
          .catch(() => {
            this.ShowToast('', 'El documento no fue encontrado', 'error');
          });
      }
    },
    async onSaveAnswerFiles(payload) {
      await _saveAnswerFiles(payload)
        .then(() => {
          this.ShowToast(
            'Proceso Exitoso',
            'Archivos de respuesta cargados exitosamente',
            'success'
          );
          this.callInterfaceFiles();
        })
        .catch((err) => {
          this.ShowToast('', err.response.data.message, 'error');
        });
    },
    async onDeleteFileAnswerHandler(interfaceFileId, fileTypeCode) {
      if (interfaceFileId && fileTypeCode) {
        const { data: response } = await _deleteInterfaceFileAnswer(
          interfaceFileId,
          fileTypeCode
        );
        if (response) {
          this.ShowToast(
            'Proceso Exitoso',
            'El archivo de respuesta ha sido eliminado exitosamente',
            'success'
          );
          this.callInterfaceFiles();
        }
      }
    },
  },
};
</script>
